import gql from 'graphql-tag'
import client from '@stores/apollo'
import { FloorPlanFragment } from '@api/fragments'
import { IFloorPlan } from '@api/types'

interface Payload {
  data: {
    employee: {
      locationAdmins: IFloorPlan[]
    }
  }
}

export default function managedLocations(id: string): Promise<IFloorPlan[]> {
  return client.gql
    .query({ query, variables: { id } })
    .then(({ data: { employee } }: Payload) => employee.locationAdmins)
}

const query = gql`
  query EmployeeManagedLoiocations($id: ID!) {
    employee: node(id: $id) {
      ... on Employee {
        locationAdmins {
          floorPlan {
            ...FloorPlanFragment
          }
        }
      }
    }
  }
  ${FloorPlanFragment}
`
